import { render, staticRenderFns } from "./add-remarks.vue?vue&type=template&id=13fda402"
import script from "./add-remarks.vue?vue&type=script&lang=js"
export * from "./add-remarks.vue?vue&type=script&lang=js"
import style0 from "./add-remarks.vue?vue&type=style&index=0&id=13fda402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports